# -*- coding: utf-8 -*-
<template>
	<Space v-if="hasData">
		<template v-if="!target.deleted">
			<Button
				v-if="target.statusData.action === 'stop' && mode === 'baseline'"
				@click="onStatusChange(target.id, 'restart')"
			>
				{{ $t('baseStationActionBar.restart') }}
			</Button>
			<Tooltip
				v-if="target.statusData.action === 'stop' && mode === 'baseStation' && target.baselineIds.length > 0"
				:trigger="['hover']"
				placement="top"
				:title="$t('baseStationActionBar.stopBaselinesOnStop')"
			>
				<Button @click="onStatusChange(target.id, 'stop')">{{ $t('baseStationActionBar.stop') }}</Button>
			</Tooltip>
			<Button
				v-if="target.statusData.action === 'stop' && !(mode === 'baseStation' && target.baselineIds.length > 0)"
				@click="onStatusChange(target.id, 'stop')"
			>
				{{ $t('baseStationActionBar.stop') }}
			</Button>
			<Button
				v-else-if="target.statusData.action === 'start'"
				class="start-button"
				:disabled="mode === 'baseline' && !store.settings?.brdc_enabled"
				@click="onStatusChange(target.id, 'start')"
			>
				{{ $t('baseStationActionBar.start') }}
			</Button>
			<Button v-else-if="target.statusData.action === 'processing'" disabled>{{ $t('baseStationActionBar.processing') }}</Button>

			<PopconfirmButton
				:ok-text="$t('baseStationActionBar.deleteButtonLabel')"
				:cancel-text="$t('baseStationActionBar.cancelButtonLabel')"
				:onConfirm="() => onStatusChange(target.id, 'delete')"
			>
				<template #title>
					<div v-html="deleteConfirmation"></div>
				</template>
				{{ $t('baseStationActionBar.delete') }}
			</PopconfirmButton>
		</template>

		<Button type="primary" v-else @click="onStatusChange(target.id, 'restore')">{{ $t('baseStationActionBar.restore') }}</Button>
	</Space>
</template>

<script>
import { computed, toRef } from 'vue';

import { useI18n } from 'vue-i18n';

import { Button, Space, Tooltip } from 'ant-design-vue';

import PopconfirmButton from '@/components/common/PopconfirmButton.vue';

import Consts from '@/api/Consts';
import Utils from '@/api/Utils';

export default {
	name: 'ChangeStatusActionBar',
	components: {
		Button, Space, Tooltip, PopconfirmButton,
	},
	emits: ['start', 'stop', 'delete', 'restore'],
	props: {
		target: {
			type: Object,
			required: false,
		},
		store: {
			type: Object,
			required: true,
		},
		mode: { // baseStation | baseline
			type: String,
			required: true,
		}
	},
	setup(props, { emit }) {
		const { t } = useI18n();
		const targetRef = toRef(props, 'target');
		const hasData = computed(() => Utils.isObjectWithData(targetRef.value));
		const onStatusChange = (key, action) => {
			const emitFunc = () => { emit(action) };
			props.store.changeStatuses([key], action, emitFunc);
		}
		const modeRef = toRef(props, 'mode');
		const deleteConfirmation = computed(() => {
			let result = t('baseStationActionBar.deleteConfirmation');
			if (modeRef.value === 'baseStation' && targetRef.value.baselineIds.length > 0) {
				result += '.<br>' + t('baseStationActionBar.stopBaselinesOnDelete');
			}
			return result;
		});
		return {
			hasData,
			deleteConfirmation,
			onStatusChange,

			colorSuccess: Consts.COLORS.success,
			colorSuccessLight: Consts.COLORS.successLight,
			colorSuccessUltraLight: Consts.COLORS.successUltraLight,
			colorSuccessUltraDark: Consts.COLORS.successUltraDark,
			colorError: Consts.COLORS.error,
			colorErrorLight: Consts.COLORS.errorLight,
			colorErrorUltraLight: Consts.COLORS.errorUltraLight,
			colorErrorUltraDark: Consts.COLORS.errorUltraDark,
		}
	}
}
</script>

<style scoped>
.start-button {
	background-color: v-bind(colorSuccessUltraLight);
	border-color: v-bind(colorSuccessLight);
	color: v-bind(colorSuccessUltraDark);
}

.start-button:hover,
.start-button:focus {
	background-color: v-bind(colorSuccessLight);
	border-color: v-bind(colorSuccess);
	color: v-bind(colorSuccessUltraDark);
}
</style> 